import { ApiStatus } from "../types/api/status"
import { useDispatch, useSelector } from "../redux/store"
import { CustomSnackbar } from "../components/common/CustomSnackbar/CustomSnackbar"
import { readLocalStorage } from "../toolbox/helpers/local-storage-helpers"
import { LocalStorageKey, RoutesMap } from "../types"
import { changeStatus, onSetSelectedSpecificSubcategory, selectSpecificSubcategoryState, setAction } from "../redux/slices/specificSubcategorySlice"
import { SpecificSubcategory } from "../types/slices/specificSubcategoryType"
import { SpecificSubcategoryAPI } from "../apis/SpecificSubcategoryAPI"
import { useLocation } from 'react-router-dom'

export const useSpecificSubcategoryStore = () => {

    const dispatch = useDispatch()
    const { specificSubcategories, specificSubcategorySelected, status, action } = useSelector(selectSpecificSubcategoryState)

    const { pathname } = useLocation()
    const userData = readLocalStorage(LocalStorageKey.USER_DATA)
    const idcompany = userData?.idcompany

    const getSpecificsubcategories = async (search='') => {
        try {
            dispatch(changeStatus(ApiStatus.FETCHING))
            const response = await SpecificSubcategoryAPI.getSpecificsubcategories({search:search})
            if (!response?.status) {
                dispatch(changeStatus(ApiStatus.FETCHED))
                CustomSnackbar('error', response.data.message || "");
                return false; 
            }
            const { detail } = response.data
            dispatch(changeStatus(ApiStatus.FETCHED))
            return detail;
        } catch (error) {
            console.log(error)
            return dispatch(changeStatus(ApiStatus.FETCHED))
        }
    }

    const getSpecificsubcategoriesByCompany = async (search='') => {
        try {
            dispatch(changeStatus(ApiStatus.FETCHING))
            const response = await SpecificSubcategoryAPI.getSpecificsubcategoriesByCompany({search:search, idcompany: idcompany})
            if (!response?.status) {
                dispatch(changeStatus(ApiStatus.FETCHED))
                CustomSnackbar('error', response.data.message || "");
                return false; 
            }
            const { detail } = response.data
            dispatch(changeStatus(ApiStatus.FETCHED))
            return detail;
        } catch (error) {
            console.log(error)
            return dispatch(changeStatus(ApiStatus.FETCHED))
        }
    }

    const getSpecificsubcategoriesBySubCategory = async (search='', idsubcategory:number) => {
        try {
            dispatch(changeStatus(ApiStatus.FETCHING))
            const response = await SpecificSubcategoryAPI.getSpecificsubcategoriesBySubCategory({search:search, idsubcategory:idsubcategory, idcompany: idcompany})
            if (!response?.status) {
                dispatch(changeStatus(ApiStatus.FETCHED))
                if(pathname != RoutesMap.PRICE_LIST) CustomSnackbar('error', response.data.message || "");
                return false; 
            }
            const { detail } = response.data
            dispatch(changeStatus(ApiStatus.FETCHED))
            return detail;
        } catch (error) {
            console.log(error)
            return dispatch(changeStatus(ApiStatus.FETCHED))
        }
    }

    const createSpecificsubcategory = async (data: any) => {
        try {
            dispatch(changeStatus(ApiStatus.FETCHING))
            const response = await SpecificSubcategoryAPI.createSpecificsubcategory({...data, idcompany: idcompany})
            if (!response?.status) {
                dispatch(changeStatus(ApiStatus.FETCHED))
                CustomSnackbar('error', response.data.message || "");
                return false;
            }
            dispatch(changeStatus(ApiStatus.FETCHED))
            CustomSnackbar('success', response.data.message  || "");
            return true;
        } catch (error) {
            console.log(error)
            return dispatch(changeStatus(ApiStatus.FETCHED))
        }
    }

    const editSpecificsubcategory = async (idsubcategory: number, data: any) => {
        try {
        dispatch(changeStatus(ApiStatus.FETCHING))
            const response = await SpecificSubcategoryAPI.editSpecificsubcategory(idsubcategory, {...data, idcompany: idcompany})
            if (!response?.status) {
                dispatch(changeStatus(ApiStatus.FETCHED))
                CustomSnackbar('error', response.data.message || "");
                return false;
            }
            dispatch(changeStatus(ApiStatus.FETCHED))
            CustomSnackbar('success', response.data.message  || "");
            return true;
        } catch (error) {
            console.log(error)
            return dispatch(changeStatus(ApiStatus.FETCHED))
        }
    }

    const deleteSpecificsubcategory = async (idsubcategory: number) => {
        try {
            dispatch(changeStatus(ApiStatus.FETCHING))
            const response = await SpecificSubcategoryAPI.deleteSpecificsubcategory(idsubcategory)
            if (!response?.status) {
                dispatch(changeStatus(ApiStatus.FETCHED))
                CustomSnackbar('error', response.data.message || "");
                return false;
            }
            dispatch(changeStatus(ApiStatus.FETCHED))
            CustomSnackbar('success', response.data.message  || "");
            return true;
        } catch (error) {
            console.log(error)
            return dispatch(changeStatus(ApiStatus.FETCHED))
        }
    }

    const setSelectedSpecificSubcategory = (subcategory: SpecificSubcategory) => {
        try {
            dispatch(onSetSelectedSpecificSubcategory(subcategory))
        } catch (error) {
            console.log(error)
        }
    }

    const setActionSpecificSubcategory = (state) => {
        try {
            dispatch(setAction(state))
        } catch (error) {
            console.log(error)
        }
    }

    return {
        //states
        specificSubcategories,
        specificSubcategorySelected,
        status,
        action,
        //actions
        getSpecificsubcategories,
        getSpecificsubcategoriesByCompany,
        getSpecificsubcategoriesBySubCategory,
        createSpecificsubcategory,
        editSpecificsubcategory,
        deleteSpecificsubcategory,
        setSelectedSpecificSubcategory,
        setActionSpecificSubcategory,
    }
}